import { Roles, Role } from '@atlassian/cssxp-typescommon';
import { getEnvironment, PRODUCTION } from '@atlassian/temp-shared';

enum EnvPrefix {
  STAGING = 'css-xp-staging-dl',
  PRODUCTION = 'css-xp-prod-dl',
}

const getEnvPrefix = () => (getEnvironment() === PRODUCTION ? EnvPrefix.PRODUCTION : EnvPrefix.STAGING);

const envPrefix = getEnvPrefix();

const principalToRoles: { [principal: string]: Role } = {
  [`${envPrefix}-customer-advocate`]: Roles.CUSTOMER_ADVOCATE,
  [`${envPrefix}-loyalty-advocate`]: Roles.LOYALTY_ADVOCATE,
  [`${envPrefix}-enterprise-advocate`]: Roles.ENTERPRISE_ADVOCATE,
  [`${envPrefix}-product-advocate`]: Roles.PRODUCT_ADVOCATE,
  [`${envPrefix}-developer-advocate`]: Roles.DEVELOPER_ADVOCATE,
  [`${envPrefix}-contract-advocate`]: Roles.CONTRACT_ADVOCATE,
};

export const getUserRoles = (principals: string[]) => {
  const roles: Role[] = [];
  principals.forEach((principal) => {
    if (principalToRoles[principal]) {
      roles.push(principalToRoles[principal]);
    }
  });
  return roles;
};
